import AdminLayout from "@/components/AdminLayout";
import ChatLayout from "@/components/ChatLayout";
import LoginLayout from "@/components/LoginLayout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import PlaygroundPage from "@/pages/PlaygroundPage";
import RegisterPage from "@/pages/RegisterPage";
import UploadPatternPage from "@/pages/UploadPatternPage";
import AdminAuditsPage from "@/pages/admin/AuditsPage";
import AdminPixelArtPage from "@/pages/admin/PixelArtPage";
import AdminUsersPage from "@/pages/admin/UsersPage";
import { createBrowserRouter, Navigate } from "react-router";

export const router = createBrowserRouter([
  {
    element: <LoginLayout />,
    children: [
      { path: "/login", element: <LoginPage /> },
      { path: "/register", element: <RegisterPage /> },
    ],
  },
  {
    element: (
      <ProtectedRoute>
        <ChatLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: "/", element: <Navigate to="/create" replace /> },
      { path: "/create", element: <UploadPatternPage /> },
      { path: "/playground", element: <PlaygroundPage /> },
    ],
  },
  {
    element: (
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: "/admin/users", element: <AdminUsersPage /> },
      { path: "/admin/audit", element: <AdminAuditsPage /> },
      { path: "/admin/pixel-art", element: <AdminPixelArtPage /> },
    ],
  },
  {
    path: "/unauthorized",
    element: (
      <div className="flex min-h-screen items-center justify-center">
        <h1 className="text-2xl font-bold">Unauthorized</h1>
      </div>
    ),
  },
  {
    path: "*",
    element: <Navigate to="/create" replace />,
  },
]);
